import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
// @src imports
import { GiftTile } from 'src/gift_store/components'
import { getGifts, GiftFragment } from 'src/graphql'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { useQueries } from 'src/hooks'

interface Props {
  id?: number
  viewGift: (slug: string) => void
  addGift: (gift: GiftFragment) => void
  giftsQuery: ReturnType<typeof getGifts>
}

const GiftTiles: React.FC<Props> = props => {
  const { addGift, viewGift, giftsQuery } = props

  const [gifts] = useQueries(giftsQuery)

  return (
    <>
      {gifts.map((item, index) => (
        <GiftTile
          id={`gift_tile_${props.id}_${index}`}
          item={item}
          key={item.id}
          viewGift={() => viewGift(item.id)}
          addGift={() => addGift(item)}
        />
      ))}
    </>
  )
}

const Unresolved = () => (
  <div style={{ background: 'transparent', boxShadow: 'none' }}>
    <CircularProgress />
  </div>
)

export default suspenseBoundary({
  component: GiftTiles,
  failure: error => `Failed loading gifts: ${error}`,
  unresolved: <Unresolved />,
})
